module.exports = __webpack_public_path__ + "static/olive-tapenade-c345c85ddbe14635d1fe63f3e02c58e4.png";